'use client';

import React from 'react';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  // Log full error details to console
  console.error('Signature Journeys Error:', error);
  console.error('Error stack:', error.stack);
  console.error('Error digest:', error.digest);
  console.error('Error name:', error.name);
  console.error('Error message:', error.message);
  console.error('Full error object:', JSON.stringify(error, Object.getOwnPropertyNames(error)));

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-2xl w-full space-y-8">
        <div className="bg-white shadow-xl rounded-lg p-8">
          <div className="text-center">
            <h2 className="text-3xl font-extrabold text-gray-900 mb-4">
              Error Loading Journeys
            </h2>
            <div className="mt-4 p-4 bg-red-50 border border-red-200 rounded-lg">
              <p className="text-sm font-mono text-red-800 whitespace-pre-wrap break-all">
                {error.message}
              </p>
              {error.digest && (
                <p className="text-xs text-red-600 mt-2">
                  Digest: {error.digest}
                </p>
              )}
              {error.stack && (
                <details className="mt-4">
                  <summary className="cursor-pointer text-sm font-semibold text-red-700">
                    Stack Trace
                  </summary>
                  <pre className="mt-2 text-xs text-red-600 overflow-auto max-h-96 bg-red-100 p-4 rounded">
                    {error.stack}
                  </pre>
                </details>
              )}
            </div>
            <button
              onClick={reset}
              className="mt-6 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
            >
              Try again
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
